
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(47[27]|86[37]|296|333|711|770|945)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
